import { Box, Toolbar } from '@material-ui/core';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import { useAppSelector } from '../reduxhooks';
import NavBar from './NavBar';
import { RenderBlockElement } from './PageComponentElementBlocks';

// Terbebas homepage: renders the merchant's StoreConfig.homepage blocks
// (same UIBlockElement vocabulary as collection layouts). Stores without a
// curated homepage land on /shop directly.
export default function PageHomeCommerce() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  const profile = useAppSelector(state => state.storeProfile.profile);
  const status = useAppSelector(state => state.storeProfile.status);
  const catalogStatus = useAppSelector(state => state.productsList.status);

  // Blocks reference products — wait for both profile and catalog.
  if (status === APIRequestStatus.Idle || status === APIRequestStatus.RequestInProgress
    || catalogStatus === APIRequestStatus.Idle || catalogStatus === APIRequestStatus.RequestInProgress) {
    return null;
  }

  const blocks = Array.isArray(profile?.config?.homepage) ? (profile!.config!.homepage as any[]) : [];

  if (!blocks.length) {
    return <Redirect to="/shop" />;
  }

  return (
    <Box>
      <NavBar transparentAtTop={false} transparent={false} coloredAtTop={false} largerTitleAtTop={false} />
      <Toolbar />
      {
        blocks.map((block, i) => (
          <RenderBlockElement
            key={i}
            code={isDesktop ? block.elementDesktopCode : block.elementMobileCode}
            contentJson={isDesktop ? block.elementDesktopContentJson : block.elementMobileContentJson}
          />
        ))
      }
    </Box>
  );
}
